export default {
  getText: state => state.item
}



// WEBPACK FOOTER //
// ./src/store/modules/texts/getters.js